import { Component, OnInit, Input } from '@angular/core';
import { ContentPageModel, StringWithHyperlinkParametersModel } from '../../../model/models';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SectionTextModel } from '../../../model/sectionTextModel';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css']
})
export class PaymentReceiptComponent implements OnInit {

  @Input()
  receiptInfoContent : ContentPageModel = {};

  constructor() { }

  ngOnInit() {
  }
  
  mapStringWithHyperlinkParameters(header: StringWithHyperlinkParametersModel) {

    let text = header.StringContent;
    let contentModel : SectionContentModel=new SectionContentModel();
    if (header.Hyperlinks.length != 0) {

      for (let i = 0; i < header.Hyperlinks.length; i++) {
        let headerSectionText = new SectionTextModel();
        let str: string = "{" + i + "}";
        headerSectionText.text = text.split(str)[0];
        let strToReplace: string = text.split(str)[0] + str;
        text = text.replace(strToReplace, "");
        headerSectionText.link = header.Hyperlinks[i].LinkText;
        headerSectionText.href = header.Hyperlinks[i].Href;

        contentModel.textList.push(headerSectionText);
      }
      if(text){
        let sectionTextModel = new SectionTextModel();
        sectionTextModel.text=text;
        contentModel.textList.push(sectionTextModel)
      }
    }
    if (header.Hyperlinks.length == 0){
      let headerSectionText = new SectionTextModel();
      headerSectionText.text = header.StringContent;
      contentModel.textList.push(headerSectionText);
    }
    return contentModel;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/payment/payment-receipt/payment-receipt.component.ts